import React, { useEffect, useState } from "react";
import { api, fmtNum, fmtDate } from "@finance/lib/api";
import { TableEmpty } from "@finance/components/DesignSystem";

export function Pending1470() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState({});
  useEffect(() => { api.get("/gl/1470-by-supplier").then((r) => setD(r.data)).catch(() => setD({ suppliers: [], total: 0, gl_balance: 0, ties: true })); }, []);
  if (!d) return <div className="text-sm text-gray-400">Loading…</div>;
  return (
    <div className="rounded-sm border border-gray-200 bg-white" data-testid="pending-1470-rollup">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 px-4 py-3">
        <div>
          <div className="font-display font-semibold">1470 · Supplier advances pending EFD — by supplier</div>
          <div className="text-xs text-gray-500">Paid before the EFD receipt. Shown as memo lines on each supplier statement, not in the balance.</div>
        </div>
        <span className={`rounded-sm px-2 py-1 text-xs font-semibold ${d.ties ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`} data-testid="pending-1470-tie">
          {d.ties ? "✓" : "⚠"} GL 1470 TZS {fmtNum(d.gl_balance)} · Register TZS {fmtNum(d.total)}
        </span>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-gray-50 lx-label text-gray-500"><tr>
          <th className="px-4 py-2 text-left">Supplier</th><th className="px-4 py-2 text-right">Open items</th><th className="px-4 py-2 text-right">Amount (TZS)</th>
        </tr></thead>
        <tbody>
          {!d.suppliers.length && <TableEmpty colSpan={3} message="Nothing pending EFD." />}
          {d.suppliers.map((g) => (
            <React.Fragment key={g.supplier_id || "none"}>
              <tr className="cursor-pointer border-b border-gray-100 hover:bg-gray-50" data-testid={`pending-1470-row-${g.supplier_id || "none"}`} onClick={() => setOpen({ ...open, [g.supplier_id]: !open[g.supplier_id] })}>
                <td className="px-4 py-2 font-medium">{g.supplier}</td>
                <td className="px-4 py-2 text-right">{g.items.length}</td>
                <td className="px-4 py-2 text-right lx-num">{fmtNum(g.amount)}</td>
              </tr>
              {open[g.supplier_id] && g.items.map((it) => (
                <tr key={it.source_id} className="border-b border-dashed border-gray-100 text-xs text-gray-500">
                  <td className="px-8 py-1.5">{fmtDate(it.date)} · {it.xp_no || "—"} · {it.description || ""}</td><td /><td className="px-4 py-1.5 text-right lx-num">{fmtNum(it.amount)}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
          <tr className="bg-gray-50 font-semibold"><td className="px-4 py-2">Total</td><td /><td className="px-4 py-2 text-right lx-num" data-testid="pending-1470-total">TZS {fmtNum(d.total)}</td></tr>
        </tbody>
      </table>
    </div>
  );
}
